import { Button } from "../../components/Button";
import { Card } from "../../components/Card";

export function PromotionsChannelPromoCard({
  channelUrl,
  err,
  ok,
  submitting,
  onVerify,
}) {
  return (
    <Card
      variant="light"
      className="promotionsPromoCard"
      title="Подпишись на канал в Telegram"
      subtitle="Открой канал, нажми «Подписаться», затем «Проверить подписку» — сервер проверит участие через бота. Отписка грозит обнулением ВСЕХ!!! бонусов."
    >
      <div className="promotionsPromoCard__form">
        <a
          className="promotionsChannelLinkPill"
          href={channelUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Открыть канал
        </a>
        {err ? <p className="errorMessage">{err}</p> : null}
        {ok ? <p className="successMessage">{ok}</p> : null}
        <Button type="button" variant="accent" disabled={submitting} onClick={onVerify}>
          {submitting ? "Проверка…" : "Проверить подписку"}
        </Button>
      </div>
    </Card>
  );
}
